import React from 'react';
import styles from './APIDocs.module.css';

const APIDocs = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>

        <div className={styles.messageBox}>
          <h2 className={styles.messageTitle}>Our Developers are working on it.</h2>
        </div>

      </div>
    </div>
  );
};

export default APIDocs;